import { RouteDictionary } from '../router';

export const pageTitles = {
  [RouteDictionary.Home]: 'nx_dashboard'
};
